import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActiveSpell, General, Spell } from "../../../../lib/types";
import HelpIcon from "../../../Common/HelpIcon";
import { castSpell, disperseSpell, setAutocast } from "../../../../store/actions";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  govId?: number;
  mana?: number;
  availableSpells?: Spell[];
  activeSpells: ActiveSpell[];
  autocast?: Array<Pick<Spell, "id" | "family">>;
  mageGeneral?: General;
  disperse: boolean;
}

const SpellList = ({
  govId,
  mana,
  availableSpells,
  activeSpells,
  autocast,
  mageGeneral,
  disperse
}: IProps) => {
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const dispatch = useDispatch();

  return (
    <div className="box scrollable">
      <table className="table">
        <thead>
        <tr>
          <th className="icon-column hidden-xs"/>
          <th className="text-left">Spell</th>
          <th className="text-center">Level</th>
          <th className="text-center">Current effect</th>
          <th className="text-center">Duration</th>
          {availableSpells
            ? <>
              <th className="text-center">Auto<span className="hidden-xs">cast</span></th>
              <th className="text-center">Price</th>
              <th className="text-center">Cast</th>
            </>
            : <>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </>
          }
        </tr>
        </thead>
        <tbody>
        {
          (availableSpells || []).map((spell) => {
            const activeSpell = activeSpells.find(active => active.spell.family === spell.family);
            const castBlockMessage = (!mageGeneral && "You need mage general to cast the spells.")
              || (spell.blocked && (spell.generalSpell ? "Cooldown after last count" : "Magic Palace not built"))
              || ((!mana || mana < spell.price) && "Not enough mana");

            return (
              <tr>
                <td className="text-center hidden-xs">
                  <i className="icon icon-kouzlo-poz positive"/>
                </td>
                <td className="no-wrap">
                  <strong>{spell.name}</strong>
                  &nbsp;<HelpIcon
                  title={spell.name}
                  content={spell.description}
                  iconClasses={["white"]}
                />
                </td>
                <td className="text-center">
                  {spell.buff ? (activeSpell ? activeSpell.spell : spell).level : "-"}
                </td>
                <td className="text-center">
                  {activeSpell
                    ? <span>{activeSpell.effectDescription}</span>
                    : <span>-</span>}
                </td>
                <td className="text-center">
                  {activeSpell
                    ? <span>{activeSpell.power} {activeSpell.spell.durationCounts ? "count" : "turns"}</span>
                    : <span>-</span>}
                </td>
                {availableSpells
                  ? <>
                    {!govId && <td className="text-center centered">
                      {mageGeneral
                        ? <div
                          className={`checkbox-wrap ${autocast && autocast.some((auto: Pick<Spell, "id" | "family">) => auto.family === spell.family) ? "checked" : ""}`}
                          onClick={() => dispatch(setAutocast(spell.id))}
                        >
                          <input
                            type="checkbox"
                            className={`checkbox ${autocast && autocast.some((auto: Pick<Spell, "id" | "family">) => auto.family === spell.family) ? "checked" : ""}`}
                            checked={autocast && autocast.some((auto: Pick<Spell, "id" | "family">) => auto.family === spell.family)}
                          />
                        </div>
                        : <i className="icon icon-x-kriz icon-standalone negative"/>
                      }
                    </td>}
                    <td className="text-center">
                      <em>{spell.price}</em> mana
                    </td>
                    <td className="text-right">
                      {activeSpell
                        ? <p className="text-center text-info-bigger">Already active<br/>
                          <a
                            className="link"
                            onClick={() => dispatch(
                              disperseSpell(activeSpell.spell.id, govId, govId === id)
                            )}
                          >
                            Disperse
                          </a>
                        </p>
                        : castBlockMessage
                          ? <p className="text-center text-info-bigger">{castBlockMessage}</p>
                          : <a
                            className="btn btn-blank btn-no-width btn-sm"
                            onClick={() => dispatch(castSpell(spell.id, govId, govId === id))}
                          >
                            Cast the spell
                          </a>
                      }
                    </td>
                  </>
                  : <>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </>
                }
              </tr>
            )
          })
        }
        {
          activeSpells.filter(spell => !(availableSpells || [])
            .map(s => s.family).includes(spell.spell.family)).map(spell => (
            <tr>
              <td className="text-center hidden-xs">
                <i className="icon icon-kouzlo-poz positive"/>
              </td>
              <td>
                <strong>{spell.spell.name}</strong>
              </td>
              <td className="text-center">
                {spell.spell.buff ? spell.spell.level : "-"}
              </td>
              <td className="text-center">
                <span>{spell.effectDescription}</span>
              </td>
              <td className="text-center">
                {spell.power} {spell.spell.durationCounts > 0 ? "count" : "turns"}
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              {disperse ? <td className="text-right">
                <p className="text-center text-info-bigger">Active<br/>
                  {spell.spell.buff ? <a
                    className="link"
                    onClick={() => dispatch(disperseSpell(spell.spell.id, govId, govId === id))}
                  >
                    Disperse
                  </a> : <></>}
                </p>
              </td> : <td/>}
            </tr>))
        }
        </tbody>
      </table>
      {(!availableSpells || !availableSpells.length) && !activeSpells.length
        ? <div className={"text-info"}>
          <p>{`No active ${disperse ? "or available " : ""}spells`}</p>
        </div> : <></>
      }
    </div>
  )
}

export default SpellList;
